import React from "react";

export const CONFIG = {
    UPDATE_FAVOURITE: '/api/apartment/like/',
}